export default "__VITE_ASSET__BYbawKA5__"